import { createContext } from "react";

const StoryContext = createContext();

export default StoryContext;